import React from 'react';
import Pageheader from '../utils/headerHelment';
import Dataroom2 from '../components/Dataroom2.0';

/** Classic dataroom kept reachable while the new VDR UI is the primary /dataroom entry. */
const DataroomClassicView = () => {
    return (
        <>
            <Pageheader title="LENS - Data Room (Classic)" />
            <Dataroom2 />
        </>
    );
};

export default DataroomClassicView;
